import { Paginator, ServerStatus } from '@/models/globalModels';
import { BadgeItemType, LoyaltyTier, LoyaltyReducerPropsType, LoyaltyTask, PointSystemInfo } from '@/models/loyaltyModels';

import { RootState } from '../../rootReducer';
import * as t from '../types';

const globalState: LoyaltyReducerPropsType = {
  loyaltyStatus: ServerStatus.IDLE,
  pointsStatus: ServerStatus.IDLE,
  badgesStatus: ServerStatus.IDLE,
  tasksStatus: ServerStatus.IDLE,
  pointsData: {} as PointSystemInfo,
};

export type PossibleActions =
  | { type: 'SET_LOYALTY_POINTS'; payload: PointSystemInfo }
  | { type: 'SET_LOYALTY_POINTS_ERROR' }
  | { type: 'LOYALTY_BADGES_FETCH'; payload: Paginator<BadgeItemType> }
  | { type: 'LOYALTY_BADGES_FETCHING' }
  | { type: 'LOYALTY_BADGES_FETCH_ERROR'; payload: any }
  | { type: 'LOYALTY_TIERS_FETCH'; payload: Paginator<LoyaltyTier> }
  | { type: 'LOYALTY_TIERS_FETCHING' }
  | { type: 'LOYALTY_TIERS_FETCH_ERROR'; payload: any }
  | { type: 'LOYALTY_TASKS_FETCHING' }
  | { type: 'LOYALTY_TASKS_FETCH'; payload: Paginator<LoyaltyTask> }
  | { type: 'LOYALTY_TASKS_FETCH_ERROR'; payload: any };

const reducer = (state = globalState, action: PossibleActions): LoyaltyReducerPropsType => {
  let error;
  switch (action.type) {
    case t.SET_LOYALTY_POINTS:
      const points = Object.assign({}, action.payload);
      return {
        ...state,
        pointsData: points,
        pointsStatus: ServerStatus.FETCH,
      };
    case t.SET_LOYALTY_POINTS_ERROR:
      return {
        ...state,
        pointsStatus: ServerStatus.FETCH_ERROR,
      };

    case t.LOYALTY_BADGES_FETCHING:
      return {
        ...state,
        badgesStatus: ServerStatus.FETCHING,
      };
    case t.LOYALTY_BADGES_FETCH:
      const badges = Object.assign([], action.payload);
      // const tiers = badges.filter((i) => i.is_tier);
      return {
        ...state,
        badgesStatus: ServerStatus.FETCH,
        badgesData: badges,
        // tiers: tiers,
      };
    case t.LOYALTY_BADGES_FETCH_ERROR:
      error = action.payload;
      return {
        ...state,
        badgesStatus: ServerStatus.FETCH_ERROR,
        error: error,
      };

    case t.LOYALTY_TIERS_FETCHING:
      return {
        ...state,
        tiersStatus: ServerStatus.FETCHING,
      };
    case t.LOYALTY_TIERS_FETCH:
      const tiers = Object.assign([], action.payload);
      return {
        ...state,
        tiersStatus: ServerStatus.FETCH,
        tiersData: tiers,
      };
    case t.LOYALTY_TIERS_FETCH_ERROR:
      error = action.payload;
      return {
        ...state,
        tiersStatus: ServerStatus.FETCH_ERROR,
        error: error,
      };

    case t.LOYALTY_TASKS_FETCHING:
      return {
        ...state,
        tasksStatus: ServerStatus.FETCHING,
      };
    case t.LOYALTY_TASKS_FETCH:
      return {
        ...state,
        tasksStatus: ServerStatus.FETCH,
        tasksData: action.payload,
      };
    case t.LOYALTY_TASKS_FETCH_ERROR:
      error = action.payload;
      return {
        ...state,
        tasksStatus: ServerStatus.FETCH_ERROR,
        error: error,
      };
    default:
      return {
        ...state,
      };
  }
};

// SELECTORS
export const selectPointSystemData = (state: RootState): PointSystemInfo => {
  const profile = state.auth.ambassadorProfile;
  if (!profile) return {} as PointSystemInfo;

  const currentTier = profile.current_tier;
  const nextTier = profile.next_tier;

  // if its the last tier, use current tier points range
  const pointsForTierEnd = nextTier?.threshold || currentTier?.threshold || 0;

  return {
    loyalty_points_earned: profile.rewards_points_earned,
    loyalty_points_available: profile.rewards_points_balance,
    // Calculated fields
    loyalty_points_tier_end: pointsForTierEnd || 0,
    loyalty_points_tier_start: currentTier?.threshold || 0,
    loyalty_points_current_tier: currentTier,
    loyalty_points_next_tier: nextTier,
    loyalty_points_current_tier_progress_value: profile.current_tier_progress_value,
  };
};

export default reducer;
